import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import SVG from 'react-inlinesvg';
import cx from 'classnames';

import { Store } from 'components/common/types/Store.types';
import { PlannerSecondaryPanelType } from 'store/dealManagement/types';
import { getDirectSalesSaveDisabled } from 'store/dealManagement/selectors';

import caretDownSVG from 'assets/icons/arrow_light_down.svg';

import useIsReadOnly from 'components/pages/Planner/useIsReadOnly';
import Duplication from './Duplication/Duplication';
import Juxtaposition from './Juxtaposition/Juxtaposition';
import ProductCategoryExclusivity from './ProductCategoryExclusivity';
import BlockedExclusion from './BlockedExclusions';
import JuxtapositionPanel from './Juxtaposition/JuxtapositionPanel';
import DuplicationPanel from './Duplication/DuplicationPanel';

const ExclusionCriteria: FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const plannerSecondaryPanelType = useSelector((state: Store) => state.dealManagement.plannerSecondaryPanelType);

  const isSaveDisabled = useSelector(getDirectSalesSaveDisabled);
  const { isCampaignReadOnly } = useIsReadOnly();

  const isDisabled = isSaveDisabled || isCampaignReadOnly;

  return (
    <div className="mx-6">
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full py-4 flex justify-between items-center disabled:cursor-not-allowed disabled:opacity-50"
        disabled={isDisabled}
        data-test-id="exclusion-criteria-toggle"
      >
        <span className="body-sm font-semibold">Exclusion criteria</span>
        <SVG
          className={cx('w-4 h-4 text-neutral-800 transition-transform', {
            'rotate-180': isExpanded,
          })}
          src={caretDownSVG}
        />
      </button>
      {isExpanded && (
        <div data-test-id="exclusion-criteria-content">
          <Duplication />
          <Juxtaposition />
          <ProductCategoryExclusivity />
          <BlockedExclusion />
        </div>
      )}
      {plannerSecondaryPanelType === PlannerSecondaryPanelType.JUXTAPOSITION && <JuxtapositionPanel />}
      {plannerSecondaryPanelType === PlannerSecondaryPanelType.DUPLICATION && <DuplicationPanel />}
    </div>
  );
};

export default ExclusionCriteria;
